module.exports = __webpack_public_path__ + "img/allinone_scan_desc.eb70f5d4.png";